import { memo } from "react";

const LayoutOnboardingTitleComponent = memo(({ title }) => {
  return (
    <div>
      <div className='relative w-fit'>
        <p className='relative text-[24px] leading-[70px] text-[#07072B] font-bold z-10'>
          {title}
        </p>
      </div>
    </div>
  );
});

export default LayoutOnboardingTitleComponent;
